export const iconFontAwesomeMoneyMoneyBill = (
	<i className="fa-solid fa-money-bill"></i>
);
